import { PaywallDisplay, setDisplayState } from 'redux/slices/paywall'
import React, { useCallback, useEffect, useRef, useState } from 'react'
import { getRemainingPasses, getShow } from 'redux/slices/liveShow'
import { useDispatch, useSelector } from 'react-redux'

import CallToActionButton from 'components/common/CallToActionButton/CallToActionButton'
import ShowCard from './ShowCard'
import clsx from 'clsx'
import { isMobile } from 'utils'
import { isSmartTV } from 'utils'
import scrollArrow from 'assets/more-indicator.svg'
import { showIsSoldOut } from 'utils/show'
import { useStyles } from './styles'

const PaywallPrompt: React.FC = () => {
    const classes = useStyles()
    const dispatch = useDispatch()

    const remainingPasses = useSelector(getRemainingPasses)
    const show = useSelector(getShow)

    const wrapper = useRef<HTMLDivElement>(null)
    const buttonRef = useRef<HTMLDivElement>(null)
    const scrollHeight = useRef(0)
    const [scrollArrowVisible, setArrowVisible] = useState(true)

    const isSoldOut = showIsSoldOut(remainingPasses)
    const shouldShowScrollIndicator = scrollArrowVisible && !isSoldOut

    const onPurchaseSelected = useCallback(() => dispatch(setDisplayState(PaywallDisplay.CHOOSE_PASS_TIER)), [dispatch])
    const onConfirmationSelected = useCallback(() => dispatch(setDisplayState(PaywallDisplay.CODE_REDEMPTION)), [
        dispatch,
    ])

    const handleScrollClick = useCallback(() => {
        buttonRef.current?.scrollIntoView()
    }, [])

    useEffect(() => {
        scrollHeight.current = wrapper.current?.offsetHeight || 0

        const handleScroll = () => {
            setArrowVisible(buttonRef.current?.getBoundingClientRect().y! > window.innerHeight)
        }

        document.addEventListener('scroll', handleScroll, true)

        return () => document.removeEventListener('scroll', handleScroll)
    }, [])

    return (
        <div
            className={clsx(
                classes.paywallWrapper,
                shouldShowScrollIndicator && classes.scrollIndicatorVisible,
                isSoldOut && classes.soldOut,
            )}
            ref={wrapper}
        >
            <div className={classes.shadowEffect} />
            {!isSmartTV && (
                <button className={classes.scrollIndicator} onClick={handleScrollClick}>
                    <img src={scrollArrow} alt="Scroll down" />
                </button>
            )}
            {show && <ShowCard show={show} />}
            <div className={classes.buttonsWrapper}>
                <div ref={buttonRef}>
                    <CallToActionButton
                        onClick={!isSoldOut ? onPurchaseSelected : () => {}}
                        type="secondary"
                        size={isMobile() ? 'normal' : 'large'}
                        display="block"
                        disabled={isSoldOut}
                        text="Register"
                        className={classes.submitPassBtn}
                        id="paywall-prompt-enter-btn"
                    />
                </div>
                <hr className={classes.separator} />
                <CallToActionButton
                    onClick={onConfirmationSelected}
                    type="white"
                    size={isMobile() ? 'normal' : 'large'}
                    display="block"
                    text="redeem code"
                    className={clsx(classes.submitPassBtn, classes.enterCodeBtn)}
                    id="paywall-prompt-code-btn"
                />
            </div>
        </div>
    )
}

export default React.memo(PaywallPrompt)
